import * as ActionTypes from 'constants';
const originalState = {
  //State
  downloaded_contacts : [],

  //Loading vars
  downloading_contacts : false,
  creating_contact : false,
  create_success : false,
};
export const contacts = (
  state = {...originalState},
  {type, payload}
) => {
  switch(type) {
    case ActionTypes.CREATE_CONTACT:
      return {...state, creating_contact : true, create_contact : false };
    case ActionTypes.CREATE_CONTACT_SUCCESS:
      return {...state, creating_contact : false, create_success : true };
    case ActionTypes.CREATE_CONTACT_FAILED:
      return {...state, creating_contact : false, create_success : false };
    case ActionTypes.CLEAR_CONTACTS:
      return {...state, ...originalState }
    case ActionTypes.FETCH_CONTACTS:
      return { ...state, downloading_contacts : true }
    case ActionTypes.FETCH_CONTACTS_SUCCESS:
      return { ...state, downloaded_contacts : payload.results, downloading_contacts : false }
    case ActionTypes.FETCH_CONTACTS_FAILED:
      return { ...state, downloaded_contacts : [], downloading_contacts : false }
    default:
      return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/common/reducers/contacts.js